/* CAMO – Customisation Process builder
   Drives the sticky bag preview in sections/camo-process-builder.liquid.
   Works with the theme editor (section load/unload, block select). */
(function () {
  if (window.CamoProcess) return;

  var RANK = { sketch: 1, leather: 2, colour: 3, personalise: 4, sample: 5, delivery: 6 };
  var KINDS = ['leather', 'colour', 'thread', 'finish'];

  function fmt(str, map) {
    return String(str || '').replace(/\[(\w+)\]/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m;
    });
  }

  function init(root) {
    if (root.__cpReady) return;
    root.__cpReady = true;

    var d = root.dataset;
    var bag = root.querySelector('[data-cp-bag]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('.cp-step'));
    var state = { step: 0, leather: null, colour: null, thread: null, finish: null, initials: '', noInitials: false, approved: false, sent: false };
    var chips = {};

    KINDS.forEach(function (kind) {
      var list = Array.prototype.slice.call(root.querySelectorAll('[data-kind="' + kind + '"]'));
      chips[kind] = list;
      state[kind] = list.filter(function (c) { return c.dataset.default === 'true'; })[0] || list[0] || null;
      list.forEach(function (chip) {
        chip.addEventListener('click', function () { state[kind] = chip; update(); });
      });
    });

    // Initials
    var input = root.querySelector('[data-cp-initials]');
    var noInitials = root.querySelector('[data-cp-no-initials]');
    if (input) {
      state.initials = input.value.toUpperCase();
      input.addEventListener('input', function () {
        var max = parseInt(input.getAttribute('maxlength'), 10) || 3;
        input.value = input.value.replace(/[^a-zA-Z&.]/g, '').toUpperCase().slice(0, max);
        state.initials = input.value;
        if (state.initials && noInitials) {
          noInitials.checked = false;
          state.noInitials = false;
        }
        update();
      });
    }
    if (noInitials) {
      noInitials.addEventListener('change', function () {
        state.noInitials = noInitials.checked;
        if (state.noInitials && input) {
          input.value = '';
          state.initials = '';
        }
        if (state.noInitials) state.finish = null;
        if (input) input.disabled = state.noInitials;
        update();
      });
    }

    // Sample approval
    var boxes = Array.prototype.slice.call(root.querySelectorAll('[data-cp-check]'));
    var orderMessageField = root.querySelector('[data-cp-order-message]');
    var wrap = root.querySelector('[data-cp-approve-wrap]');
    var approveBtn = root.querySelector('[data-cp-approve]');
    var approveNote = root.querySelector('[data-cp-approve-note]');
    function refreshApproval() {
      if (!approveBtn) return;
      var n = boxes.filter(function (b) { return b.checked; }).length;
      var total = boxes.length;
      approveBtn.disabled = state.sent || (total > 0 && n < total);
      if (state.sent || !approveNote) return;
      var map = { checked: n, total: total };
      approveNote.textContent = total === 0 ? (wrap.dataset.hint || '') : n === 0 ? fmt(wrap.dataset.hint, map) : n < total ? fmt(wrap.dataset.progress, map) : fmt(wrap.dataset.ready, map);
    }
    boxes.forEach(function (b) { b.addEventListener('change', refreshApproval); });
    if (approveBtn) {
      approveBtn.addEventListener('click', function () {
        state.sent = true;
        state.approved = boxes.length > 0;
        approveBtn.disabled = true;
        if (wrap.dataset.approvedLabel) approveBtn.textContent = wrap.dataset.approvedLabel;
        if (approveNote) approveNote.textContent = wrap.dataset.done || '';
        update();

        var phone = String(d.whatsappNumber || '').replace(/\D/g, '');
        if (!phone) return;

        var brief = orderMessageField ? orderMessageField.value.trim() : '';
        var initials = state.noInitials && noInitials ? noInitials.dataset.label : (state.initials || 'Not specified');
        var message = [
          'Hi CAMO, These are my preferences',
          '',
          'My selections:',
          'Brief: ' + (brief || 'Not specified'),
          'Leather: ' + (state.leather ? state.leather.dataset.name : 'Not selected'),
          'Colour: ' + (state.colour ? state.colour.dataset.name : 'Not selected'),
          'Thread: ' + (state.thread ? state.thread.dataset.name : 'Not selected'),
          'Initials: ' + initials,
          'Finish: ' + (state.noInitials ? 'Not applicable' : (state.finish ? state.finish.dataset.name : 'Not selected')),
          '',
          'Please let me know the next steps'
        ].join('\n');
        var whatsappUrl = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(message);
        window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
      });
      refreshApproval();
    }

    function setText(sel, text) {
      Array.prototype.forEach.call(root.querySelectorAll(sel), function (el) { el.textContent = text; });
    }

    function update() {
      KINDS.forEach(function (kind) {
        chips[kind].forEach(function (c) {
          c.setAttribute('aria-pressed', String(c === state[kind]));
          if (kind === 'finish') c.disabled = state.noInitials;
        });
      });

      var step = steps[state.step];
      var rank = RANK[step ? step.dataset.view : 'sketch'] || 1;
      var dyed = rank >= 3 && state.colour;
      var hex = dyed ? state.colour.dataset.hex : d.natural;
      var dark = dyed ? (state.colour.dataset.dark || state.colour.dataset.hex) : d.naturalDark;
      var thread = d.threadDefault;
      if (rank >= 3 && state.thread) {
        thread = state.thread.dataset.tonal === 'true' ? dark : state.thread.dataset.hex;
      }
      var ini = state.noInitials ? '' : (state.initials || d.initialsFallback || '');

      if (bag) {
        bag.style.setProperty('--bag', hex);
        bag.style.setProperty('--bag-dark', dark);
        bag.style.setProperty('--thread', thread);
        bag.setAttribute('data-rank', rank);
        bag.setAttribute('data-texture', state.leather ? state.leather.dataset.texture : d.textureDefault);
        bag.setAttribute('data-finish', state.finish ? state.finish.dataset.finish : 'blind');
      }
      setText('[data-cp-ini]', ini);
      setText('[data-cp-stamp]', state.approved ? d.stampApproved : d.stamp);

      if (step) {
        setText('[data-cp-stage]', step.dataset.name || '');
        setText('[data-cp-count]', fmt(d.counter, { current: state.step + 1, total: steps.length }));
      }
      Array.prototype.forEach.call(root.querySelectorAll('.cp-rail li'), function (li, i) {
        li.classList.toggle('is-done', i <= state.step);
      });

      var none = d.none || '';
      setText('[data-cp-spec="leather"]', state.leather ? state.leather.dataset.name : none);
      setText('[data-cp-spec="colour"]', state.colour
        ? fmt(d.colourFormat, { colour: state.colour.dataset.name, thread: state.thread ? state.thread.dataset.name : '' })
        : none);
      setText('[data-cp-spec="personal"]', state.noInitials && noInitials
        ? noInitials.dataset.label
        : state.initials
          ? fmt(d.personalFormat, { initials: state.initials, finish: state.finish ? state.finish.dataset.name : '' })
          : none);
      setText('[data-cp-spec="sample"]', state.approved ? d.sampleApproved : d.samplePending);
    }

    function activate(index) {
      if (index < 0 || index >= steps.length) return;
      state.step = index;
      steps.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      update();
    }

    var mobileViewport = window.matchMedia && window.matchMedia('(max-width: 991px)').matches;
    if (mobileViewport) {
      var scrollFrame = 0;
      var syncMobileStep = function () {
        scrollFrame = 0;
        var targetY = Math.round(window.innerHeight * 0.48);
        var activeIndex = -1;
        var nearestIndex = 0;
        var nearestDistance = Infinity;

        steps.forEach(function (step, index) {
          var rect = step.getBoundingClientRect();
          if (rect.top <= targetY && rect.bottom > targetY) activeIndex = index;
          var distance = Math.abs((rect.top + rect.bottom) / 2 - targetY);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        activate(activeIndex >= 0 ? activeIndex : nearestIndex);
      };
      var scheduleMobileStepSync = function () {
        if (!scrollFrame) scrollFrame = window.requestAnimationFrame(syncMobileStep);
      };
      window.addEventListener('scroll', scheduleMobileStepSync, { passive: true });
      window.addEventListener('resize', scheduleMobileStepSync);
      root.__cpOffStepSync = function () {
        window.removeEventListener('scroll', scheduleMobileStepSync);
        window.removeEventListener('resize', scheduleMobileStepSync);
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
      };
      syncMobileStep();
    } else if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) activate(steps.indexOf(e.target)); });
      }, { rootMargin: '-45% 0px -50% 0px' });
      steps.forEach(function (s) { io.observe(s); });
      root.__cpIO = io;
    } else {
      steps.forEach(function (s) { s.classList.add('is-active'); });
    }

    // Theme editor: selecting a block jumps to its step
    root.__cpSelect = function (el) {
      var step = el.classList && el.classList.contains('cp-step') ? el : el.closest('.cp-step');
      if (!step) return;
      activate(steps.indexOf(step));
      step.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    // Keep the sticky preview below the theme's sticky header
    if (d.autoOffset === 'true') {
      var raf = 0;
      var measure = function () {
        raf = 0;
        var header = document.querySelector('.site-header--sticky, .site-header');
        var h = 0;
        if (header) {
          var pos = window.getComputedStyle(header).position;
          var rect = header.getBoundingClientRect();
          if ((pos === 'sticky' || pos === 'fixed') && rect.bottom > 0) h = Math.round(rect.bottom);
        }
        root.style.setProperty('--cp-header-h', h + 'px');
      };
      var schedule = function () { if (!raf) raf = window.requestAnimationFrame(measure); };
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      root.__cpOffOffset = function () {
        window.removeEventListener('scroll', schedule);
        window.removeEventListener('resize', schedule);
      };
      measure();
    }

    update();
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-camo-builder]'), init);
  }

  window.CamoProcess = { init: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-camo-builder]'), function (r) {
      if (r.__cpIO) r.__cpIO.disconnect();
      if (r.__cpOffOffset) r.__cpOffOffset();
      if (r.__cpOffStepSync) r.__cpOffStepSync();
    });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest && e.target.closest('[data-camo-builder]');
    if (root && root.__cpSelect) root.__cpSelect(e.target);
  });
})();
